// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
// 假设要跳转到 HelloWorld 组件，先引入该组件
import HelloWorld from '@/components/HelloWorld.vue';
// 可以再引入其他需要跳转的组件，比如创建一个 Test 组件（需自己新建 src/components/Test.vue）



const routes = [



  {
    path: '', // 访问的路径
    name: '登录',
    component: HelloWorld // 对应的组件
  },
                     {
            path: '/xueyuan/',
            name: '学员考试选择科目',
            component: () => import( '@/kaoshiok/index.vue'),
          },
                         {
            path: '/cundang/',
            name: '学员考试存档',
            component: () => import( '@/kaoshiok/cundang.vue'),
          },
                         {
            path: '/store-query/',
            name: '门店密钥查询',
            component: () => import( '@/storequery/index.vue'),
          },
                         {
            path: '/store-query/list/',
            name: '门店上报列表',
            component: () => import( '@/storequery/list.vue'),
          },
     {
            path: '/renlian/',
            name: '学员考试人脸采集',
            component: () => import( '@/kaoshiok/renlian.vue'),
          },
        {
            path: '/kaoshi/xueyuan/',
            name: '正式考试',
            component: () => import( '@/kaoshiok/kaoshi.vue'),
          },
            {
            path: '/kaoshi/jieguo/',
            name: '考试结果',
            component: () => import( '@/kaoshiok/jieguo.vue'),
          },
                      {
            path: '/xueyuan/chaxun/',
            name: '查询考试记录',
            component: () => import( '@/kaoshiok/chaxun.vue'),
          },
  {
    path: '/home',
    name: '管理系统',
    component: () => import( '@/home/home.vue'),
    redirect: '/index',
    children:[
                              {
            path: '/geren',
            name: '个人中心',
            component: () => import( '../gerenziliao/index.vue'),
          },
                                      {
            path: '/menu/',
            name: '菜单管理',
            component: () => import( '@/menu/index.vue'),
          },
                                              {
            path: '/role/',
            name: '角色管理',
            component: () => import( '@/role/index.vue'),
          },
                                                      {
            path: '/user/',
            name: '管理员',
            component: () => import( '@/user/index.vue'),
          },

                                                                              {
            path: '/index/',
            name: '主页',
            component: () => import( '@/home/index.vue'),
          },
                                                                                      {
            path: '/ppt/',
            name: '模拟考试首页',
            component: () => import( '@/moni/index.vue'),
          },
                                                                                              {
            path: '/dati/',
            name: '答题界面',
            component: () => import( '@/moni/dati.vue'),
          },
                                                                                                      {
            path: '/jieguo/',
            name: '考试结果页面',
            component: () => import( '@/moni/jieguo.vue'),
          },

                 {
            path: '/shijuanguanli/',
            name: '试卷分类',
            component: () => import( '@/shujuan/leimu.vue'),
          },
         {
            path: '/shijuantiku/',
            name: '试卷题库',
            component: () => import( '@/shujuan/index.vue'),
          },
          {
            path: '/store/',
            name: '门店管理',
            component: () => import( '@/store/index.vue'),
          },
          {
            path: '/store/report/',
            name: '上报明细',
            component: () => import( '@/store/report.vue'),
          },
          {
            path: '/store/issued/',
            name: '已出证列表',
            component: () => import( '@/store/issued.vue'),
          },
          {
            path: '/certificate/',
            name: '证书管理',
            component: () => import( '@/certificate/index.vue'),
          },
          {
            path: '/certificate/external-paper/',
            name: '外部试卷名称配置',
            component: () => import( '@/certificate/external-paper.vue'),
          },
                 {
            path: '/dangan/',
            name: '档案列表',
            component: () => import( '@/danan/index.vue'),
          },





                {
                    path: '/kaoshi/',
                    name: '考试管理',
                    component: () => import('@/kaoshi/index.vue'),
                    children: [
                      {
                        path: 'fenlei/',
                        name: '题目分类',
                        component: () => import('@/kaoshi/fenlei.vue'),
                      },
                      {
                        path: 'timu/',
                        name: '试题管理',
                        component: () => import('@/kaoshi/timu.vue'),
                      },

                    ]
                  }





        ]
  }
];

const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 历史模式
  routes
});

export default router;